import * as React from 'react';
import { FC } from 'react';

import { StyleSheet } from 'react-native';

import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';

import BaseReceiptHeadInfo from './receipt-head-info.base';
import { IOrderHeaderProps } from './types';

const ReceiptHeadInfo: FC<React.PropsWithChildren<IOrderHeaderProps>> = ({ order }) => {
  const message = t('orderDetailsHeading');
  return (
    <>
      <Typography
        variant="headerFour"
        style={styles.title}
        focusable
        accessible
        accessibilityRole="header"
        accessibilityLabel={message}
      >
        {message}
      </Typography>
      <BaseReceiptHeadInfo order={order} />
    </>
  );
};

export default ReceiptHeadInfo;

const styles = StyleSheet.create({
  title: {
    margin: 0,
  },
});
